<script>
import palette from '@inscribe/signal/dist/palette';
import DatabasesTable from '@/V2/documents/document-view/signals/DatabasesTable';
import PreviousDocumentsTable from '@/V2/documents/document-view/signals/PreviousDocumentsTable.vue';
import TransactionSignalDetails from '@/V2/documents/document-view/signals/TransactionSignalDetails.vue';
import SignalViolations from '@/V2/documents/document-view/signals/SignalViolations.vue';
import * as SignalNames from '@/constants/signalNames';
import {
  isTransactionSignal,
  signalHasDatabasesTable,
  signalHasPreviousDocumentsTable,
  signalHasDescription,
  signalHasViolations,
} from '@/utils/signalNames';

export default {
  components: {
    DatabasesTable,
    PreviousDocumentsTable,
    TransactionSignalDetails,
    SignalViolations,
  },
  props: {
    document: {
      type: Object,
      required: true,
    },
    signalGroup: {
      type: Object,
      required: true,
    },
    signal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      palette,
      isTransactionSignal,
      signalHasDatabasesTable,
      signalHasPreviousDocumentsTable,
      signalHasDescription,
      signalHasViolations,
      reportingData: null,
      SignalNames,
    };
  },
  computed: {
    previousDocuments() {
      const signal = this.document.fraud_results[this.signalGroup.signalKey];
      return signal?.details?.documents;
    },
  },
};
</script>

<template>
  <div
    data-testid="signal-metadata"
    class="signal-metadata d-flex flex-column i-p-10"
  >
    <div class="title d-flex flex-row i-gap-6 i-mb-9">
      <div class="text flex-column align-items-start flex-grow-1">
        <div class="name i-text-button-2 i-text-neutral-120">
          {{ signalGroup.title }}
        </div>
        <div class="subtitle i-text-body-2 i-text-neutral-110">
          {{ signalGroup.subTitle }}
        </div>
      </div>
    </div>

    <!-- signal type data -->
    <!-- previous documents-->
    <previous-documents-table
      v-if="signalHasPreviousDocumentsTable(signalGroup.signalKey)"
      :document="document"
      :previous-documents="previousDocuments"
    ></previous-documents-table>

    <!-- databases -->
    <databases-table
      v-if="signalHasDatabasesTable(signalGroup.signalKey)"
      :document="document"
      :signal-group="signalGroup"
    ></databases-table>

    <!-- transactions signals -->
    <transaction-signal-details
      v-if="isTransactionSignal(signal.signalKey)"
      :signal="signal"
    ></transaction-signal-details>

    <!-- w2 social security limit exceeded -->
    <signal-violations
      v-if="signalHasViolations(signalGroup.signalKey)"
      :signal-group="signalGroup"
    ></signal-violations>

    <div
      v-if="signalHasDescription(signalGroup.signalKey)"
      class="description i-text-body-2 i-text-neutral-120"
    >
      {{ signalGroup.description }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.signal-metadata {
  .title .icon {
    min-width: 36px;
  }

  :deep(.data-container) {
    width: 100%;
  }

  :deep(.data-table) {
    width: 100%;
    background: $light-neutral-20;
  }
}
</style>
